import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult } from './types';

const cvsApi = {
  getAll(params?: cyrian.api.cvs.GetParams): ApiResponse<WrappedResult<cyrian.api.cvs.CV[]>> {
    return request({
      method: 'get',
      url: '/cvs',
      params,
    });
  },
  get(id: number): ApiResponse<WrappedResult<cyrian.api.cvs.CVWithAttachment>> {
    return request({
      method: 'get',
      url: `/cvs/${id}`,
    });
  },
  create(data: cyrian.api.cvs.CVParams): ApiResponse<WrappedResult<cyrian.api.cvs.CV>> {
    return request({
      method: 'post',
      url: '/cvs',
      data,
    });
  },
  update(id: number, data: cyrian.api.cvs.CVParams): ApiResponse<WrappedResult<cyrian.api.cvs.CV>> {
    return request({
      method: 'patch',
      url: `/cvs/${id}`,
      data,
    });
  },
  delete(id: number): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'delete',
      url: `/cvs/${id}`,
    });
  },
};

export default cvsApi;
